import { Component } from '@angular/core';
import { NgbTypeaheadSelectItemEvent } from '@ng-bootstrap/ng-bootstrap';
import { Pim, PimProductRelatedProductsComponent } from 'gung-standard';

@Component({
    selector: 'car-liner-pim-product-spare-parts',
    templateUrl: './car-liner-pim-product-spare-parts.component.html',
    styleUrl: './car-liner-pim-product-spare-parts.component.scss',
    standalone: false
})
export class CarLinerPimProductSparePartsComponent extends PimProductRelatedProductsComponent {
  
  onRelatedProductSelect(event: NgbTypeaheadSelectItemEvent) {
    const pim = event.item as Pim;

    if (!this.pimProduct.extra.pim.spareParts) {
      this.pimProduct.extra.pim.spareParts = pim.id;
    } else {
      if (this.pimProduct.extra.pim.spareParts.indexOf(pim.id) < 0) {
        this.pimProduct.extra.pim.spareParts += ',' + pim.id;
      }
    }

    event.preventDefault();
    this.modelRelatedProduct = null;
  }

  removeRelatedProduct(id: string) {
    const allRelatedProducts = this.pimProduct.extra.pim.spareParts.split(',');

    const indexToRemove = allRelatedProducts.findIndex(itemId => itemId === id);
    if (indexToRemove > -1) {
      allRelatedProducts.splice(indexToRemove, 1);
    }

    this.pimProduct.extra.pim.spareParts = allRelatedProducts.join(',');
  }
}